<template>
  <div v-if="display">
    <template v-if="mode === 'default'">
      <header class="f-row header-default">
        <div class="f-row header-two-section">
          <button class="hamburger-menu">
            <Icon icon="bars" />
          </button>
        </div>
        <div class="f-row header-two-section">
          <UserBox />
        </div>
      </header>
    </template>
    <template v-else-if="mode === 'editor'">
      <header class="f-row header-editor">
        <div class="f-row header-three-section">
          <button class="hamburger-menu">
            <Icon icon="bars" />
          </button>
        </div>
        <div class="f-row header-three-section">
          <router-link class="editor-exit" to="/editor">Sair do modo editor</router-link>
        </div>
        <div class="f-row header-three-section">
          <UserBox />
        </div>
      </header>
    </template>
    <template v-else-if="mode === 'outside'">
      <header class="f-row header-outside"></header>
    </template>
  </div>
</template>

<script>
import UserBox from "../library/UserBox";

export default {
  name: "Header",
  components: {
    UserBox
  },
  computed: {
    display() {
      return this.$store.state.header.display;
    },
    mode() {
      return this.$store.state.header.mode;
    }
  }
};
</script>

<style scoped>
.header-default {
  justify-content: space-between;
  height: 58px;
  max-height: 58px;
  min-height: 58px;
  padding: 0 0.6rem;
  color: #2e3e4e;
  background-color: #f9f9f9;
  border-bottom: 1px solid #ddd;
}

.header-editor {
  justify-content: space-between;
  height: 58px;
  max-height: 58px;
  min-height: 58px;
  padding: 0 0.6rem;
  color: #2e3e4e;
  background-color: #f0f0f0;
  border-bottom: 1px solid #ddd;
}

.header-outside {
  justify-content: space-between;
  height: 58px;
  max-height: 58px;
  min-height: 58px;
  padding: 0 0.6rem;
  color: #2e3e4e;
  background-color: #f9f9f9;
  border-bottom: 1px solid #ddd;
}

.header-two-section {
  width: 50%;
  height: 100%;
}

.header-two-section:nth-of-type(1) {
  justify-content: flex-start;
}

.header-two-section:nth-of-type(2) {
  justify-content: flex-end;
}

.header-three-section {
  width: 33%;
  height: 100%;
}

.header-three-section:nth-of-type(1) {
  justify-content: flex-start;
}

.header-three-section:nth-of-type(2) {
  justify-content: center;
}

.header-three-section:nth-of-type(3) {
  justify-content: flex-end;
}

.hamburger-menu {
  padding: 5px;
  margin-right: 5px;
  font-size: 20px;
}

.editor-exit {
  padding: 6px 8px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  text-align: center;
  text-transform: uppercase;
  color: #f1f1f1;
  background: #405060;
  border-radius: 0.25rem;
}
</style>